import { html } from 'lit';
import { sectionHeading } from '../components/sectionHeading.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const valuesSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    class=${editorNodeClass(editor, 'section.values', 'vp-section vp-values-section')}
    style=${editorNodeStyle(editor, 'section.values')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.values', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.values', event)}
  >
    <div class="vp-shell">
      ${sectionHeading({
        eyebrow: content.values.eyebrow,
        title: content.values.title,
        highlight: content.values.titleHighlight,
        text: content.values.text,
        align: 'center',
        editor,
        elementPrefix: 'values',
      })}

      <div
        class=${editorNodeClass(editor, 'values.items', 'vp-card-grid vp-card-grid-three vp-values-grid')}
        style=${editorNodeStyle(editor, 'values.items')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'values.items', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'values.items', event)}
      >
        ${content.values.items.map(
          (item, index) => html`
            <article
              class=${editorNodeClass(editor, `values.item.${index}`, 'vp-info-card vp-value-card reveal-card')}
              style=${editorNodeStyle(editor, `values.item.${index}`)}
              @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `values.item.${index}`, event)}
              @click=${(event: MouseEvent) => editorNodeClick(editor, `values.item.${index}`, event)}
            >
              <span
                class=${editorNodeClass(editor, `values.item.${index}.icon`, `${item.iconClass} vp-value-card-icon`)}
                style=${editorNodeStyle(editor, `values.item.${index}.icon`)}
                @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `values.item.${index}.icon`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `values.item.${index}.icon`, event)}
              ></span>
              <h3
                class=${editorNodeClass(editor, `values.item.${index}.title`)}
                style=${editorNodeStyle(editor, `values.item.${index}.title`)}
                @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `values.item.${index}.title`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `values.item.${index}.title`, event)}
              >
                ${item.title}
              </h3>
              <p
                class=${editorNodeClass(editor, `values.item.${index}.text`)}
                style=${editorNodeStyle(editor, `values.item.${index}.text`)}
                @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `values.item.${index}.text`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `values.item.${index}.text`, event)}
              >
                ${item.text}
              </p>
            </article>
          `,
        )}
      </div>

      <div
        class=${editorNodeClass(editor, 'values.bridge', 'vp-values-bridge reveal-card')}
        style=${editorNodeStyle(editor, 'values.bridge')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'values.bridge', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'values.bridge', event)}
      >
        <span class="vp-values-bridge-flags" aria-hidden="true">
          <span class="icon-[material-symbols--public]"></span>
        </span>
        <div class="vp-values-bridge-copy">
          <h3
            class=${editorNodeClass(editor, 'values.bridgeTitle')}
            style=${editorNodeStyle(editor, 'values.bridgeTitle')}
            @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'values.bridgeTitle', event)}
            @click=${(event: MouseEvent) => editorNodeClick(editor, 'values.bridgeTitle', event)}
          >
            ${content.values.bridgeTitle}
          </h3>
          <p
            class=${editorNodeClass(editor, 'values.bridgeText')}
            style=${editorNodeStyle(editor, 'values.bridgeText')}
            @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'values.bridgeText', event)}
            @click=${(event: MouseEvent) => editorNodeClick(editor, 'values.bridgeText', event)}
          >
            ${content.values.bridgeText}
          </p>
          ${content.values.bridgeAction
            ? html`<a
                class=${editorNodeClass(editor, 'values.bridgeAction.label', 'vp-values-bridge-action')}
                style=${editorNodeStyle(editor, 'values.bridgeAction.label')}
                href=${content.values.bridgeAction.href}
                @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'values.bridgeAction.label', event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, 'values.bridgeAction.label', event)}
                >${content.values.bridgeAction.label}
                <span class="icon-[material-symbols--arrow-forward]"></span>
              </a>`
            : ''}
        </div>
      </div>
    </div>
  </section>
`;
